import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-c157939a")
const _hoisted_1 = { class: "p-text-left" }
const _hoisted_2 = {
  key: 0,
  class: "p-d-flex"
}
const _hoisted_3 = {
  key: 1,
  class: "p-d-flex"
}
const _hoisted_4 = {
  key: 0,
  class: "text-size-12"
}
const _hoisted_5 = {
  key: 1,
  class: "p-d-flex p-flex-wrap text-gray-900 w100",
  style: {"font-size":"9px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-6 p-p-0" }, "Estudiantes que valoraron: ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-2 p-p-0 bg-problem text-black p-text-center" }, " Malo ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-2 p-p-0 bg-regular text-black p-text-center" }, " Regular ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-2 p-p-0 bg-good text-black p-text-center" }, " Bueno ", -1)
const _hoisted_10 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 2,
  class: "w100 text-size-12"
}
const _hoisted_12 = { class: "pi pi-info-circle text-red-brain text-size-12" }
const _hoisted_13 = {
  key: 3,
  class: "text-size-12"
}
const _hoisted_14 = {
  key: 1,
  class: "w100"
}
const _hoisted_15 = {
  key: 2,
  class: "w100"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 3,
  class: "w100 p-text-center text-size-12"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 1,
  class: "linkStyle disabled"
}
const _hoisted_21 = {
  key: 0,
  class: "text-size-12 p-text-center",
  style: {"width":"100%"}
}
const _hoisted_22 = {
  key: 1,
  class: "p-d-flex p-jc-around w100"
}
const _hoisted_23 = { class: "p-col-4 p-p-0 p-text-center bg-problem" }
const _hoisted_24 = { class: "p-col-4 p-p-0 p-text-center bg-regular" }
const _hoisted_25 = { class: "p-col-4 p-p-0 p-text-center bg-good" }
const _hoisted_26 = {
  key: 2,
  class: "p-text-center w100 text-size-12"
}
const _hoisted_27 = { key: 3 }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  key: 4,
  class: "text-size-12 w100 p-text-center"
}
const _hoisted_31 = {
  key: 5,
  class: "text-size-12 w100 p-text-center"
}
const _hoisted_32 = { key: 6 }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_34 = [
  _hoisted_33
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CoderBadge = _resolveComponent("CoderBadge")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!
  const _directive_parentclass = _resolveDirective("parentclass")!

  return (_openBlock(), _createBlock(_component_DataTable, {
    class: "staffRating ch-datatable p-datatable-ssm",
    responsiveLayout: "scroll",
    loading: 
      _ctx.loading || !_ctx.dateColumns || (_ctx.dateColumns && _ctx.dateColumns.length <= 1)
    ,
    value: _ctx.rows,
    scrollable: true,
    showGridlines: ""
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", null, [
          (_ctx.teacher)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_router_link, {
                  to: {
                name: _ctx.EducationRouteNames.PERSON_PROFILE_GENERAL,
                params: {
                  personId: _ctx.teacher.user?.personId
                }
              }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.teacher.profile?.name) + " " + _toDisplayString(_ctx.teacher.profile?.lastName), 1)
                  ]),
                  _: 1
                }, 8, ["to"]),
                (_ctx.teacher.user?.role === _ctx.PersonRoles.Teacher)
                  ? (_openBlock(), _createBlock(_component_CoderBadge, {
                      key: 0,
                      text: _ctx.StaffMember.getTeacherStatus(_ctx.teacher)?.name,
                      backgroundColor: _ctx.StaffMember.getTeacherStatus(_ctx.teacher)?.color,
                      fontSize: "12px",
                      padding: "0px 4px",
                      rounded: ""
                    }, null, 8, ["text", "backgroundColor"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (
              _ctx.evaluateSummary === _ctx.EvaluateSummary.content && _ctx.syllabusVersion
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Programa versión " + _toDisplayString(_ctx.syllabusVersion), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Column, {
        key: _ctx.defaultColumns[0].field,
        header: _ctx.defaultColumns[0].header,
        frozen: true,
        style: {"min-width":"250px"}
      }, {
        body: _withCtx(({ data }) => [
          (data.firstRow)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(data[_ctx.defaultColumns[0].field]), 1))
            : (data.secondRow)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_10))
              : (data.grayRow)
                ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_11, [
                    _createTextVNode(_toDisplayString(data[_ctx.defaultColumns[0].field]) + " ", 1),
                    _withDirectives(_createElementVNode("i", _hoisted_12, null, 512), [
                      [
                        _directive_tooltip,
                        
              'En cada columna se separa la cantidad de asistentes a las clases por sobre la cantidad de veces que se eligió una tag en particular.'
            ,
                        void 0,
                        {
                          top: true,
                          blur: true
                        }
                      ]
                    ])
                  ], 512)), [
                    [_directive_parentclass, 'bg-gray']
                  ])
                : _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_13, [
                    _createTextVNode(_toDisplayString(data[_ctx.defaultColumns[0].field]), 1)
                  ], 512)), [
                    [_directive_parentclass, data.green ? 'bg-green' : 'bg-blank']
                  ])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        key: _ctx.defaultColumns[1].field,
        header: _ctx.defaultColumns[1].header,
        style: {"min-width":"60px"},
        headerClass: 'p-d-flex p-jc-center text-size-12'
      }, {
        body: _withCtx(({ data }) => [
          (data.firstRow)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass([[
            _ctx.getClassNameByAVGRating(data[_ctx.defaultColumns[1].field]),
            'text-size-12'
          ], "w100 p-text-center "])
              }, _toDisplayString(_ctx.isNumber(data[_ctx.defaultColumns[1].field])
              ? _ctx.truncate(data[_ctx.defaultColumns[1].field])
              : ' '), 3))
            : (data.secondRow)
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, " "))
              : (data.grayRow)
                ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_15, _hoisted_17, 512)), [
                    [_directive_parentclass, 'bg-gray']
                  ])
                : _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_18, [
                    _createTextVNode(_toDisplayString(data[_ctx.defaultColumns[1].field]), 1)
                  ], 512)), [
                    [_directive_parentclass, data.green ? 'bg-green' : 'bg-blank']
                  ])
        ]),
        _: 1
      }, 8, ["header"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateColumns, (col) => {
        return (_openBlock(), _createBlock(_component_Column, {
          key: col.field,
          style: {"min-width":"60px"},
          headerClass: 'p-d-flex p-jc-center text-size-12'
        }, {
          header: _withCtx(() => [
            (
            _ctx.hasFeedback(
              _ctx.feedbacks,
              col.field,
              _ctx.evaluateSummary,
              _ctx.teacher?.user?.personId
            )
          )
              ? _withDirectives((_openBlock(), _createElementBlock("a", {
                  key: 0,
                  onClick: ($event: any) => (_ctx.changeView(col.field)),
                  class: "linkStyle"
                }, [
                  _createTextVNode(_toDisplayString(col.header), 1)
                ], 8, _hoisted_19)), [
                  [
                    _directive_tooltip,
                    
            _ctx.classes.find(c => c._id === col.field)?.name || ''
          ,
                    void 0,
                    {
                      top: true,
                      blur: true
                    }
                  ]
                ])
              : _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_20, [
                  _createTextVNode(_toDisplayString(col.header), 1)
                ], 512)), [
                  [
                    _directive_tooltip,
                    
            (_ctx.classes.find(c => c._id === col.field)
              ? _ctx.classes.find(c => c._id === col.field)?.name
              : '') + ' (No hay Feedback)'
          ,
                    void 0,
                    {
                      top: true,
                      blur: true
                    }
                  ]
                ])
          ]),
          body: _withCtx(({ data }) => [
            (data.firstRow)
              ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_21, [
                  _createTextVNode(_toDisplayString(data[col.field] ? _ctx.truncate(data[col.field]) : ' '), 1)
                ], 512)), [
                  [_directive_parentclass, _ctx.getClassNameByAVGRating(data[col.field])]
                ])
              : (data.secondRow)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, _toDisplayString(data[col.field]?.negativeTags || 0), 1),
                    _createElementVNode("div", _hoisted_24, _toDisplayString(data[col.field]?.neutralTags || 0), 1),
                    _createElementVNode("div", _hoisted_25, _toDisplayString(data[col.field]?.positiveTags || 0), 1)
                  ]))
                : (data.grayRow && _ctx.isNumber(data[col.field]))
                  ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_26, [
                      _createTextVNode(_toDisplayString(data[col.field]) + "/ " + _toDisplayString(_ctx.teacher && _ctx.classesWithStudentAttendances
              ? _ctx.classesWithStudentAttendances[col.field][_ctx.teacher.user.personId]
                  ?.length ||
                _ctx.classesMap.get(col.field)?.studentAttendances?.length
              : _ctx.classesMap.get(col.field)?.studentAttendances?.length), 1)
                    ], 512)), [
                      [_directive_parentclass, 'bg-gray']
                    ])
                  : (data.grayRow)
                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_27, _hoisted_29, 512)), [
                        [_directive_parentclass, 'bg-gray']
                      ])
                    : (data.green && _ctx.isNumber(data[col.field]))
                      ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_30, [
                          _createTextVNode(_toDisplayString(data[col.field]) + "/ " + _toDisplayString(_ctx.teacher && _ctx.classesWithStudentAttendances
              ? _ctx.classesWithStudentAttendances[col.field][_ctx.teacher.user.personId]
                  ?.length ||
                _ctx.classesMap.get(col.field)?.studentAttendances?.length
              : _ctx.classesMap.get(col.field)?.studentAttendances?.length), 1)
                        ], 512)), [
                          [_directive_parentclass, 'bg-green']
                        ])
                      : (_ctx.isNumber(data[col.field]))
                        ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_31, [
                            _createTextVNode(_toDisplayString(data[col.field]) + "/ " + _toDisplayString(_ctx.teacher && _ctx.classesWithStudentAttendances
              ? _ctx.classesWithStudentAttendances[col.field][_ctx.teacher.user.personId]
                  ?.length ||
                _ctx.classesMap.get(col.field)?.studentAttendances?.length
              : _ctx.classesMap.get(col.field)?.studentAttendances?.length), 1)
                          ], 512)), [
                            [_directive_parentclass, 'bg-red']
                          ])
                        : _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_32, _hoisted_34, 512)), [
                            [_directive_parentclass, data.green ? 'bg-green' : 'bg-blank']
                          ])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }, 8, ["loading", "value"]))
}